// services/ScheduleService.js
import Axhelper from '@/lib/Axhelper'

class ScheduleService {
	constructor() {
		this.baseUrl = window.RUNTIME_CONFIG.API_URL;
		this.endpoints = {
			all: `/api/schedule/all`,
			startend: `/api/schedule/startend`,
			create: `/api/schedule`,
			update: `/api/schedule`, 
			deleteOne: `/api/schedule`, 
			details: `/api/schedule/details`,
			bycustomer: `/api/schedule/customerschedules`,
		}
	}

	async getAll() {
		try {
			const res = await Axhelper.sendGetAsync(this.endpoints.all)
			if (res.error) return { data: [], error: res.error }
			return { data: res.data || [], error: null }
		} catch (e) {
			console.error('ScheduleService.getAll error:', e)
			return { data: [], error: e.message || 'Failed to fetch schedule' }
		}
	}

	async getByCustomerId(customerId) {
		try {
			if (!customerId) return { data: [], error: 'Invalid customer ID provided' }
			const url = `${this.endpoints.bycustomer}/${encodeURIComponent(customerId)}`
			const res = await Axhelper.sendGetAsync(url)
			if (res.error) return { data: [], error: res.error }
			return { data: res.data || [], error: null }
		} catch (e) {
			console.error('ScheduleService.getByCustomerId error:', e)
			return { data: [], error: e.message || 'Failed to fetch schedule' }
		}
	}

	async getByDateRange(start, end) {
		try {
			if (!start || !end) return { data: [], error: 'Start and end dates are required' }
			const url = `${this.endpoints.startend}/${encodeURIComponent(start)}/${encodeURIComponent(end)}`
			const res = await Axhelper.sendGetAsync(url)
			if (res.error) return { data: [], error: res.error }
			return { data: res.data || [], error: null }
		} catch (e) {
			console.error('ScheduleService.getByDateRange error:', e)
			return { data: [], error: e.message || 'Failed to fetch schedule' }
		}
	}

	async getById(id) {
		try {
			if (!id) return { data: null, error: 'Invalid schedule ID provided' }
			const url = `${this.endpoints.details}/${encodeURIComponent(id)}`
			const res = await Axhelper.sendGetAsync(url)

			if (res.error) return { data: null, error: res.error }
			
			return { data: res.data || null, error: null }
		} catch (e) {
			console.error('ScheduleService.getById error:', e)
			return { data: null, error: e.message || 'Failed to fetch booking' }
		}
	}

	async create(payload) {
		try {
			const res = await Axhelper.sendPostAsync(this.endpoints.create, payload)
			if (res.error) return { success: false, error: res.error }
			return { success: true, error: null, data: res.data || null }
		} catch (e) {
			console.error('ScheduleService.create error:', e)
			return { success: false, error: e.message || 'Failed to create booking' }
		}
	}

	async update(id, payload) {
		try {
			if (!id) return { success: false, error: 'Invalid schedule ID provided' }
			const url = `${this.endpoints.update}/${encodeURIComponent(id)}`
			const res = await Axhelper.sendPutAsync(url, payload)
			if (res.error) return { success: false, error: res.error }
			return { success: true, error: null, data: res.data || null }
		} catch (e) {
			console.error('ScheduleService.update error:', e)
			return { success: false, error: e.message || 'Failed to update booking' }
		}
	}

	async deleteOne(id) {
		try {
			if (!id) return { success: false, error: 'Invalid schedule ID provided' }
			const url = `${this.endpoints.deleteOne}/${encodeURIComponent(id)}`
			const res = await Axhelper.sendDeleteAsync(url)
			if (res.error) return { success: false, error: res.error }
			return { success: true, error: null, message: res.data || 'Deleted' }
		} catch (e) {
			console.error('ScheduleService.deleteOne error:', e)
			return { success: false, error: e.message || 'Failed to delete booking' }
		}
	}
}

export default new ScheduleService()
